import AssessmentResume from './components/assessment-resume';
import Car from './components/car';
import Call from './components/call';
import ChallengeComplete from './components/challenge-complete';
import ChallengeCompleteGold from './components/challenge-complete-gold';
import ChallengeCompletePlatinum from './components/challenge-complete-platinum';
import ChallengeCompleteSilver from './components/challenge-complete-silver';
import ChallengeFailed from './components/challenge-failed';
import Chevron from './components/chevron';
import ChevronDown from './components/chevron-down';
import ChevronUp from './components/chevron-up';
import Cross from './components/cross';
import CrossCircleFilled from './components/cross-circle-filled';
import Cup from './components/cup';
import CurrentLocation from './components/current-location';
import DownArrow from './components/down-arrow';
import Eiffel from './components/eiffel';
import ErrorCircle from './components/error-circle';
import Home from './components/home';
import Info from './components/info';
import Location from './components/location';
import MagGlass from './components/mag-glass';
import Envelope from './components/envelope';
import More from './components/more';
import NotificationBell from './components/notification-bell';
import Placeholder from './components/placeholder';
import Question from './components/question';
import Resync from './components/resync';
import RightArrow from './components/right-arrow';
import RightArrowHead from './components/right-arrow-head';
import Running from './components/running';
import RunningShoe from './components/running-shoe';
import Star from './components/star';
import StepsChallenge from './components/steps-challenge';
import Tick from './components/tick';
import TickOutline from './components/tick-outline';
import TieringCup from './components/tiering-cup';
import Walking from './components/walking';
import Comment from './components/comment';
import Heart from './components/heart';
import Mobile from './components/mobile';
import Recognise from './components/recognise';
import Pen from './components/pen';
import OpenNewPage from './components/open-new-page';
import PlusOutline from './components/plus-outline';

export {
  AssessmentResume,
  Call,
  Car,
  ChallengeComplete,
  ChallengeCompleteGold,
  ChallengeCompletePlatinum,
  ChallengeCompleteSilver,
  ChallengeFailed,
  Chevron,
  ChevronDown,
  ChevronUp,
  Cross,
  CrossCircleFilled,
  Cup,
  CurrentLocation,
  DownArrow,
  Eiffel,
  ErrorCircle,
  Home,
  Info,
  Location,
  MagGlass,
  More,
  Envelope,
  NotificationBell,
  Placeholder,
  Question,
  Resync,
  RightArrow,
  RightArrowHead,
  Running,
  RunningShoe,
  Star,
  StepsChallenge,
  Tick,
  TickOutline,
  TieringCup,
  Walking,
  Comment,
  Heart,
  Mobile,
  Recognise,
  Pen,
  OpenNewPage,
  PlusOutline,
};

export type IconName =
  | 'AssessmentResume'
  | 'Call'
  | 'Car'
  | 'ChallengeComplete'
  | 'ChallengeCompleteGold'
  | 'ChallengeCompletePlatinum'
  | 'ChallengeCompleteSilver'
  | 'ChallengeFailed'
  | 'Chevron'
  | 'ChevronUp'
  | 'ChevronDown'
  | 'Cross'
  | 'CrossCircleFilled'
  | 'Cup'
  | 'CurrentLocation'
  | 'DownArrow'
  | 'Eiffel'
  | 'ErrorCircle'
  | 'Home'
  | 'Info'
  | 'Location'
  | 'MagGlass'
  | 'Envelope'
  | 'NotificationBell'
  | 'Placeholder'
  | 'Question'
  | 'Resync'
  | 'RightArrow'
  | 'RightArrowHead'
  | 'Running'
  | 'RunningShoe'
  | 'Star'
  | 'StepsChallenge'
  | 'Tick'
  | 'TickOutline'
  | 'TieringCup'
  | 'Comment'
  | 'Mobile'
  | 'Heart'
  | 'Walking'
  | 'Recognise'
  | 'OpenNewPage'
  | 'PlusOutline'
  | 'Pen';
